function formatStatus(value: string): string {
  return value
    .replace(/[_-]+/g, ' ')
    .replace(/\s+/g, ' ')
    .trim()
    .replace(/^./, (first) => first.toUpperCase());
}

const STATUS_CHIP_CLASS_NAMES: Record<string, string> = {
  active: 'bg-emerald-100 text-emerald-800',
  redeemable: 'bg-emerald-100 text-emerald-800',
  scheduled: 'bg-sky-100 text-sky-800',
  draft: 'bg-neutral-100 text-neutral-700',
  paused: 'bg-amber-100 text-amber-800',
  expired: 'bg-orange-100 text-orange-800',
  redeemed: 'bg-blue-100 text-blue-800',
  archived: 'bg-neutral-200 text-neutral-700',
};

export function VoucherStatusChip({ state }: { state: string }) {
  const className = STATUS_CHIP_CLASS_NAMES[state] ?? 'bg-neutral-100 text-neutral-700';

  return (
    <span className={`inline-flex rounded-full px-2.5 py-1 text-small font-medium ${className}`}>
      {formatStatus(state)}
    </span>
  );
}
